import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-company",
  "use": "icon-company-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-company\"><defs><style type=\"text/css\"></style></defs><path d=\"M949.8 313.5L503.7 65.6l-446 247.9 446.1 247.4 446-247.4zM57.7 412.2v99.2l446.1 247.8 446.1-247.8v-99.2L503.7 660.1l-446-247.9z m0 198.5v99.2l446.1 247.8 446.1-247.8v-99.2L503.7 858.5l-446-247.8z\" p-id=\"1890\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/company.svg
// module id = znPN
// module chunks = 65